import type { FC } from 'react'

import type { OptaTeamStanding } from '@sportworld/js-sdk/src/types/soccerDataTypes'

import { Column, TableRowWrapper } from '../styles'
import type { StandingsRowProps } from '../types'

export const TableRow: FC<StandingsRowProps<OptaTeamStanding>> = ({
  focusId,
  team,
  columns,
  onClick,
  firstColHighlighted = false,
  highlightColor,
  rowHighlighted = false,
}) => (
  <TableRowWrapper
    focusId={focusId}
    onSelected={() => onClick?.(team, focusId)}
    $firstColHighlighted={firstColHighlighted}
    $firstColHighlightColor={highlightColor}
    $rowHighlighted={rowHighlighted}
  >
    {columns.map(({ width, accent, render }, index) => (
      <Column key={index} $width={width} $accent={accent}>
        {render(team)}
      </Column>
    ))}
  </TableRowWrapper>
)
